// Copyright (c) 2016 Deere & Company

import Claim, {getDefaultState as getClaimDefaultState} from '@deere/cps-it.warranty-model-factory/lib/claim-mass-channel-pdi';
import {
    findMatchingAccount,
    findMatchingKey
} from '../../../shared/services/claim-shared-helper';
import ClaimAction from '@deere/cps-it.warranty-model-factory/lib/claim-action';
import actions from '../../../action-list';
import {getDefaultState as getDefaultPinState} from '@deere/cps-it.warranty-model-factory/lib/pdi-pin';
import {getDefaultState} from '../state';

const setMassChannelPdiClaim = (state, action) =>
    Claim.update(state, {
        $set: action.updatedClaim
    });

const updatePins = state =>
    Claim.update(state, {
        pins: {
            $push: [getDefaultPinState(), getDefaultPinState(), getDefaultPinState()]
        }
    });

const updateClaimMode = (state, action) => action.isEditable ?
    updatePins(state, Claim) :
    state;

const copyClaim = state => {

    const defaultClaim = getClaimDefaultState();

    return Claim.update(state, {
        $merge: {
            allowedActions: [
                new ClaimAction({
                    actionName: 'DRAFT',
                    id: 'DRAFT',
                    mode: 'CHG'
                }),
                new ClaimAction({
                    actionName: 'SAVE_VALD',
                    id: 'SAVE_VALD',
                    mode: 'CHG'
                })
            ],
            claimNumber: defaultClaim.claimNumber,
            claimStatus: defaultClaim.claimStatus,
            claimValueDetails: defaultClaim.claimValueDetails,
            errors: defaultClaim.errors,
            recordInfo: defaultClaim.recordInfo,
            reimbursementDetails: defaultClaim.reimbursementDetails
        }
    });

};

const updateClaimProperty = (state, action) =>
    Claim.update(state, {
        [action.property]: {
            $set: action.value
        }
    });

const updateClaimReferenceInfoProperty = (state, action) =>
    Claim.update(state, {
        referenceInfo: {
            [action.property]: {
                $set: action.value
            }
        }
    });

const updateResponsibleAccounts = (state, action) =>
    Claim.update(state, {
        responsibleAccount: {
            $set: findMatchingAccount(action.accountId, action.dealerCollection)
        }
    });

const updateRetailerName = (state, action) =>
    Claim.update(state, {
        retailerName: {
            $set: findMatchingKey(action.key, action.retailerNameCollection)
        }
    });

const updateGoodsInstallationVat = (state, action) =>
    Claim.update(state, {
        goodsInstallationVat: {
            $set: findMatchingKey(action.key, action.goodsInstallationOptions)
        }
    });

const resetMassChannelPdiClaim = () => getClaimDefaultState();

const addFile = (state, action) =>
    Claim.update(state, {
        file: {
            $push: [action.data]
        }
    });

const deleteFile = (state, action) => {

    const index = state.file.findIndex(file => file.serialNumber === action.data.serialNumber && file.name === action.data.name);

    return Claim.update(state, {
        file: {
            $splice: [[index, 1]]
        }
    });

};

const updateFile = (state, action) =>
    Claim.update(state, {
        file: {
            $set: action.files
        }
    });

const updatePin = (state, action) =>
    Claim.update(state, {
        pins: {
            [action.index]: {
                pin: {$set: action.value}
            }
        }
    });

const reviseClaim = state =>
    Claim.update(state, {
        errors: {
            $set: []
        }
    });

export default (state = getDefaultState().claim, action) => {

    const actionTypes = {
        [actions.ADD_CLAIM_MASS_CHANNEL_PDI_FILE]: addFile,
        [actions.DELETE_CLAIM_MASS_CHANNEL_PDI_FILE]: deleteFile,
        [actions.COPY_CLAIM_MASS_CHANNEL_PDI]: copyClaim,
        [actions.RESET_CLAIM_MASS_CHANNEL_PDI]: resetMassChannelPdiClaim,
        [actions.REVISE_CLAIM_MASS_CHANNEL_PDI]: reviseClaim,
        [actions.SET_CLAIM_MASS_CHANNEL_PDI]: setMassChannelPdiClaim,
        [actions.UPDATE_CLAIM_MASS_CHANNEL_PDI_REFERENCE_INFO_PROPERTY]: updateClaimReferenceInfoProperty,
        [actions.UPDATE_CLAIM_MASS_CHANNEL_PDI_GOODS_INSTALLATION_VAT]: updateGoodsInstallationVat,
        [actions.UPDATE_CLAIM_MASS_CHANNEL_PDI_FILE]: updateFile,
        [actions.UPDATE_CLAIM_MASS_CHANNEL_PDI_RETAILER_NAME]: updateRetailerName,
        [actions.UPDATE_CLAIM_MASS_CHANNEL_PDI_IS_EDITABLE]: updateClaimMode,
        [actions.UPDATE_CLAIM_MASS_CHANNEL_PDI_PROPERTY]: updateClaimProperty,
        [actions.UPDATE_CLAIM_MASS_CHANNEL_PDI_PIN]: updatePin,
        [actions.ADD_CLAIM_MASS_CHANNEL_PDI_PINS]: updatePins,
        [actions.UPDATE_CLAIM_MASS_CHANNEL_PDI_RESPONSIBLE_ACCOUNTS]: updateResponsibleAccounts
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-pdi/reducers/mass-channel-pdi-claim.js